module.exports = __webpack_public_path__ + "static/Carshare-1c1398a0ed2a67fc9b6322a596929bb3.svg";